// Variables
let openMenu = false;

// PARSE POST DATA
function postData(url = '', data) {
	var boundary = String(Math.random()).slice(2); // needed for form data
	return fetch(url, {
			method: 'POST', // *GET, POST, PUT, DELETE, etc.
			mode: 'cors', // no-cors, cors, *same-origin
			cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
			credentials: 'same-origin', // include, *same-origin, omit
			headers: {
				// 'Content-Type': 'application/json',
				'Content-Type': 'application/x-www-form-urlencoded'
				//'Content-Type', 'multipart/form-data; boundary=' + boundary
			},
			redirect: 'follow', // manual, *follow, error
			referrer: 'no-referrer', // no-referrer, *client
			body: data, // the data type in the  body must match the value of the "Content-Type" header
		})
		.then(response => response.text()); // parses the JSON response into a Javascript object
}

// ELEMENT OFFSET COORDS
function getCoords(elem) { // not IE8-
	var box = elem.getBoundingClientRect();

	return {
		top: box.top + pageYOffset,
		left: box.left + pageXOffset
	};

}

// LOTTIE
const lottieAnimation = () => {
	// Get all elements with class .lottie
	let selectors = document.getElementsByClassName('lottie');

	if (selectors.length == 0 || selectors == null) return;

	Array.prototype.map.call(selectors, selector => {
		let jsonPath = selector.dataset.animation,
			img = selector.dataset.img ? selector.dataset.img : false;

		selector.dataset.animation = '';

		const response = fetch(jsonPath)
			.then(response => response.json())
			.then(data => {
				let params = {
					container: selector,
					renderer: 'svg',
					loop: true,
					autoplay: true,
					animationData: data,
					assetsPath: img,
					rendererSettings: {
						progressiveLoad: true,
					}
				};

				lottie.loadAnimation(params)
			})
			.catch(error => {
				console.error('Error:', error);
			});
	})

}

// MODAL MENU
const mobileMenu = () => {
	let btn = document.querySelector('.site-header-mobmenu'),
		mobmenu = document.querySelector('.site-header-mobile'),
		bgoverlay = document.querySelector('.sdc-overlay');
	if (btn) {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			mobmenu.classList.toggle('active');
			btn.classList.toggle('active');
			if (mobmenu.classList.contains('active')) {
				openMenu = true;
			} else {
				openMenu = false;
			}
			document.body.classList.toggle('open');
		});
		bgoverlay.addEventListener('click', (e) => {
			openMenu = false;
			document.body.classList.remove('open');
			mobmenu.classList.remove('active');
			btn.classList.remove('active');
		})
	}
}

// SEARCHFORM
const searchform = () => {
	if (!document.forms.searchform) return;
	let form = document.forms.searchform,
		icon = form.querySelector('.searchform-icon');

	icon.addEventListener('click', () => form.classList.add('searchform-show'));

	document.addEventListener('click', (event) => {
		if (!form.contains(event.target)) {
			form.classList.remove('searchform-show');
		}
	})
}

// SINGLE POSTS STICKY HEADER
const scrollPost = () => {
	if (!document.body.classList.contains('single-post')) return false;

	let postHeader = document.querySelector('.post-header-sticky'),
		postContainer = document.querySelector('.post-container'),
		postHero = document.querySelector('.post-hero'),
		scrollPosition = 0;

	window.addEventListener('scroll', () => {
		let dist = postContainer.offsetHeight - (window.innerHeight / 2),
			pos = window.scrollY - getCoords(content).top,
			progress = pos / dist,
			range = `${progress * 100}%`;

		if (progress > 0.1 && progress < 1) {

			postHeader.classList.add('sticky');
			scrollPos = document.body.getBoundingClientRect().top;

		} else {
			// Remove fix
			postHeader.classList.remove('sticky')

		}
	});
}

// GET LINK HASH
const getLinkHash = (element) => {
   if (!element) return
	return element.hash.replace('#', '')
}
// SMOOTH SCROLL
const smoothScroll = (elements) => {
	if (!elements) return

	elements.forEach(element => {
		element.addEventListener('click', (event) => {
			let hash = getLinkHash(element);
			let target = document.getElementById(hash);
			if (target) {
		  		event.preventDefault()
				let positionY = target.getBoundingClientRect().top + window.pageYOffset,
					windowHeight = window.innerHeight,
					to = positionY - (windowHeight / 2 )

				window.scrollTo({
					top: to,
					behavior: "smooth"
				})
       		}
		})
	})
}
// GET USER ID
const getUUID = () => {
	let cookie = new SDC_Cookie,
	user_id = cookie.getCookie('sdc_user_id')

	if ( ! user_id ) return

	return user_id
}

let btnClickAnimation = ( selector ) => {
	if ( ! selector ) return

	let btns = document.querySelectorAll( selector )

	if ( ! btns ) return false

	btns.forEach( btn => {
		btn.addEventListener( 'click', () => {
			btn.classList.add('hover')
			setTimeout(() => {
				btn.classList.remove('hover')
			}, 500)
		})
	})

}

/**
 * Send data to TikTok
 *
 * @param string event Event name
 * @returns void
 */
let tiktokAnalytics = (event) => {
	if ( ! window.ttq ) return

	ttq.track(event);
}

/**
 * Redirect after time
 *
 * @param string url
 * @param number timeout (time in miliseconds)
 */
let delayedRedirect = (url, timeout) => {
	setTimeout(() => {
		window.location.assign(url);
	}, timeout)
}

/**
 * Send data after click on the link
 *
 * @param string selector (element class or ID)
 * @returns void
 */
const trackLink = (selector) => {
  let links = document.querySelectorAll(selector);

	if ( ! links ) return false

  links.forEach( (link) => {
    link.addEventListener( 'click', (e) => {
			e.preventDefault()
			let url = link.href

			// fbq('track', 'Lead', {}, {eventID: getUserID()+'-1', event_id: getUserID()+'-1'})
			// tiktokAnalytics('Download')
			// delayedRedirect(url, 1000)

		})
  })
}

/**
 * Call Functions
 */
document.addEventListener('DOMContentLoaded', () => {
	mobileMenu();
	searchform();
	scrollPost();
	lottieAnimation();
	smoothScroll(document.querySelectorAll(`a[href*="#"]`))
	btnClickAnimation('.bttn-tertiary')
	trackLink('.btn-track')
})
